import { StatusBadge, StatusBadgeVariant } from "components/StatusBadge";

interface IProps {
  status: 0 | 1 | 2 | 3 | 4;
}

const strategy: Record<number, { texto: string; variant: StatusBadgeVariant }> = {
  0: { texto: "Pendente", variant: "aviso" },
  1: { texto: "Pago", variant: "sucesso" },
  2: { texto: "Pago", variant: "sucesso" },
  3: { texto: "Processando", variant: "neutro" },
  4: { texto: "Erro", variant: "erro" },
};

export function StatusDebito({ status }: IProps) {
  const config = strategy[status] ?? strategy[0];
  return <StatusBadge label={config.texto} variant={config.variant} width="100px" />;
}
